module.exports = __webpack_public_path__ + "img/free.6b833f2.svg";